import { Swiper } from 'vue-awesome-swiper';
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      biggerImgUrl: '',
      showBigger: false,
      showMove: false
    };
  },
  watch: {
    list(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.galleryThumbsLunbo();
          this.galleryTopLunbo();
        });
      }
    }
  },
  methods: {
    galleryThumbsLunbo() {
      if (this.galleryThumbs) {
        this.galleryThumbs.destory();
      }
      this.galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 15,    // 在slide之间设置距离（单位px）
        slidesPerView: 5,    // 设置slider容器能够同时显示的slides数量
        loop: false,        // 设置为true 则开启loop模式
        freeMode: true,    // 默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 5,    // 一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true,   // 开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true   // 开启这个参数来计算每个slide的progress(进度、进程)
      });
    },
    galleryTopLunbo() {
      if (this.galleryTop) {
        this.galleryTop.destory();
      }
      setTimeout(() => {
        this.galleryTop = new Swiper('.gallery-top', {
          // autoplay: {
          //   delay: 1000
          // },
          spaceBetween: 10,
          loop: false,
          loopedSlides: 5,
          // 左右按钮
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          thumbs: {        // thumbs组件专门用于制作带缩略图的swiper
            swiper: this.galleryThumbs
          }
        });
      }, 100);
    },

    moveAction(item, index, e) {
      const smallImg = document.getElementById('small-img' + index);
      const parent = document.getElementById('parent');
      const magnifier = document.getElementById('magnifier');
      const largeImg = document.getElementById('large-img');

      const parentRect = parent.getBoundingClientRect();
      const magnifierWidth = magnifier.offsetWidth;
      const magnifierHeight = magnifier.offsetHeight;
      const smallImgWidth = smallImg.clientWidth;
      const smallImgHeight = smallImg.clientHeight;
      this.showBigger = true;
      this.showMove = true;
      this.biggerImgUrl = item;
      const rect = smallImg.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const realX = x - magnifierWidth / 2;
      const realY = y - magnifierHeight / 2;
      magnifier.style.left = Math.max(0, Math.min(realX, smallImgWidth - magnifierWidth)) + 'px';
      magnifier.style.top = Math.max(0, Math.min(realY, smallImgHeight - magnifierHeight)) + 'px';
      const magnifieRect = magnifier.getBoundingClientRect();
      const movex = magnifieRect.left - parentRect.left;
      const movey = magnifieRect.top - parentRect.top;
      largeImg.style.transform = `scale(2) translate(-${(movex / 0.6) / 2}px, -${(movey / 0.6) / 2}px)`;
    },

    leaveAction() {
      this.showBigger = false;
      this.showMove = false;
    }
  }
};
